/**
 * Translation Context
 * 
 * Provides translation functionality throughout the app using React Context
 */

import { createContext } from 'react';

export const TranslationContext = createContext({
  currentLanguage: 'fr',
  changeLanguage: () => {},
  t: (key) => key,
  translateText: async (text) => text,
  isTranslating: false,
  supportedLanguages: [],
});

export default TranslationContext;

